<template>
    <div>
        <el-carousel @change="changeItem" ref="carousel" :autoplay="carousel['autoplay']" trigger="click" arrow="never">
            <el-carousel-item v-for="(item, index) in carousel['images']" :key="index">
                <img class="small" :src="item" alt="img" />
            </el-carousel-item>
        </el-carousel>
        <slot name="switchComponent"></slot>
    </div>
</template>

<script>
export default {
    name: 'public-carousel-component',
    props: {
        carousel: Object
    },
    methods: {
        changeItem (index) {
            this.$emit('changeItem', index)
        },
        prev () {
            this.$refs.carousel.prev()
        },
        next () {
            this.$refs.carousel.next()
        }
    }
}
</script>
